<template>
    <div>
        <h3 class="kgr-headline kgr-headline--h3 kgr-headline--text kgr-headline--firstInText">
            {{ $t('Debitorennummern') }}
            <img
                src="@img/info.png"
                alt=""
                :title="$t('Clubity erzeugt automatisch Debitorennummern nach untem aufgeführten Schema für Rechnungsempfänger, sobald Ihnen eine Gebühr zugewiesen wird.')"
            />
        </h3>

        <div>
            <div class="kgr-inputGroup">
                <div class="kgr-grid kgr-grid--1of2 kgr-grid--gutters">
                    <div class="kgr-grid__cell">
                        <div class="animated fadeIn">
                            <kgr-form-row
                                :label="$t('Nummernkreis von')"
                                :error="error"
                                field-name="accountsReceivableNumberConfig.initialCounter"
                                required
                            >
                                <input
                                    v-model.number="accountsReceivableNumberConfig.initialCounter"
                                    type="number"
                                    min="0"
                                    class="kgr-input"
                                    :disabled="false"
                                    @keyup.enter="onKeyUpEnter"
                                    @change="loadNextNumber"
                                />
                            </kgr-form-row>
                            <kgr-form-row
                                :label="$t('Nummernkreis bis')"
                                :error="error"
                                field-name="accountsReceivableNumberConfig.maxCounter"
                                required
                            >
                                <input
                                    v-model.number="accountsReceivableNumberConfig.maxCounter"
                                    type="number"
                                    min="0"
                                    class="kgr-input"
                                    :disabled="false"
                                    @change="loadNextNumber"
                                    @keyup.enter="onKeyUpEnter"
                                />
                            </kgr-form-row>
                        </div>
                    </div>
                    <div class="animated fadeIn kgr-grid__cell">
                        <div class="kgr-region kgr-region--rounded kgr-region--gray">
                            <div class="kgr-row">
                                {{ $t('Dies ist deine nächste Debitorennummer') }}:
                            </div>
                            <kgr-loading v-if="loading" />
                            <div
                                v-else
                                class="accountsReceivableSettingsPreview kgr-text kgr-text--bold"
                            >
                                {{ nextNumber }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AccountsReceivableNumberConfig from '../../../js/dto/AccountsReceivableNumberConfig';
import ClubRepository from '../../../js/repository/ClubRepository';
import Error from '../../../js/model/Error';
import FormRow from '../../common/form/FormRow';
import Loading from '../../common/Loading';

export default {
    components: {
        'kgr-form-row': FormRow,
        'kgr-loading': Loading,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        accountsReceivableNumberConfig: {
            type: AccountsReceivableNumberConfig,
            required: true,
        },
        error: {
            type: Error,
            required: true,
        },
    },
    data() {
        return {
            nextNumber: '',
            loading: false,
        };
    },
    computed: {
    },
    mounted() {
        this.loadNextNumber();
    },
    methods: {
        loadNextNumber() {
            this.loading = true;
            this.error.clear('accountsReceivableNumberConfig.initialCounter');
            this.error.clear('accountsReceivableNumberConfig.maxCounter');
            ClubRepository.getNextAccountsReceivableNumber(this.clubId, this.accountsReceivableNumberConfig)
                .then((response) => {
                    this.nextNumber = response.counter;
                })
                .catch((error) => {
                    if (error.messageForField('maxCounterReached')) {
                        this.nextNumber = error.messageForField('maxCounterReached');
                        this.nextNumber = this.$t('Es kann keine Debitorennummer mehr generiert werden, weil der Nummernkreis zu klein ist.');
                    } else {
                        this.nextNumber = this.$t('Deine Einstellungen sind ungültig.');
                    }
                    this.error.add('accountsReceivableNumberConfig.initialCounter', error.messageForField('accountsReceivableNumberConfig.initialCounter'));
                    this.error.add('accountsReceivableNumberConfig.maxCounter', error.messageForField('accountsReceivableNumberConfig.maxCounter'));
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        onKeyUpEnter() {
            this.$emit('enter');
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
